import { v4 as uuidv4 } from 'uuid';
import { generateAutomationStepId } from '../../components/AutomationStudio/utils/common';
import { EXECUTION_MODES } from '../../components/AutomationStudio/constant';

import { filterActiveInstructions, reindexPlanStepIndices, getFlatSteps } from './planUtils';

export function reindexInstructionsGlobally(instructions = []) {
    return reindexPlanStepIndices(instructions);
}

export function findStepLocation(instructions = [], stepId) {
    let flatIndex = 0;
    for (const inst of filterActiveInstructions(instructions)) {
        for (let i = 0; i < (inst.aiSteps ?? []).length; i++) {
            const step = inst.aiSteps[i];
            if (step.id === stepId) {
                return { instructionId: inst.id, stepIndexInInstruction: i, flatIndex, step };
            }
            flatIndex++;
        }
    }
    return null;
}

export function computeFlatIndex(instructions = [], instructionId, stepIndexInInstruction) {
    let flatIndex = 0;
    for (const inst of filterActiveInstructions(instructions)) {
        if (inst.id === instructionId) {
            return flatIndex + stepIndexInInstruction;
        }
        flatIndex += (inst.aiSteps ?? []).length;
    }
    return flatIndex;
}

export function buildCustomStep({ instructionId, instructionText, description = '' }) {
    return {
        id: `add-step-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        stepId: generateAutomationStepId(),
        customStep: true,
        tool: '',
        args: { instructionId },
        description,
        stepDescription: description,
        extractedData: { stepDescription: description },
        executionMode: EXECUTION_MODES.XPATH_ONLY,
        executionStrategies: [],
        status: 'pending',
        stepType: 'custom',
        timestamp: new Date().toISOString(),
        instructionId,
        instruction: { id: instructionId, text: instructionText || '' },
    };
}

export function insertStepAfter(instructions = [], instructionId, afterStepIndex, newStep) {
    const withInserted = instructions.map((inst) => {
        if (inst.id !== instructionId) return inst;
        const steps = [...(inst.aiSteps ?? [])];
        steps.splice(afterStepIndex + 1, 0, newStep);
        return { ...inst, aiSteps: steps };
    });
    return reindexPlanStepIndices(withInserted);
}

export function removeStepById(instructions = [], stepId) {
    const withoutStep = instructions.map((inst) => ({
        ...inst,
        aiSteps: (inst.aiSteps ?? []).filter((s) => s.id !== stepId),
    }));
    return reindexPlanStepIndices(withoutStep);
}

export function getAdjacentStepId(instructions = [], currentStepId, direction) {
    const flat = getFlatSteps(instructions);
    const idx = flat.findIndex((s) => s.id === currentStepId);
    if (idx === -1) return null;
    const nextIdx = direction === 'prev' ? idx - 1 : idx + 1;
    if (nextIdx < 0 || nextIdx >= flat.length) return null;
    return flat[nextIdx].id;
}

export function createDefaultInstructionWithSteps(steps = []) {
    return [{ id: uuidv4(), text: '', aiSteps: steps }];
}
